import { ReactElement } from 'react';

const Loader = (): ReactElement => (
  <svg viewBox="25 25 50 50" width={24} height={24}>
    <circle r="20" cy="50" cx="50" />
  </svg>
);
export default Loader;
